import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "indicator" }
const _hoisted_2 = { class: "indicator-value is-size-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "count-value is-size-3 is-line-height-3 has-text-weight-bold"
}
const _hoisted_5 = {
  key: 2,
  class: "subvalue use-slot"
}
const _hoisted_6 = {
  key: 0,
  class: "is-size-6"
}
const _hoisted_7 = {
  key: 1,
  class: "is-size-6"
}
const _hoisted_8 = {
  key: 2,
  class: "mdi mdi-menu-down is-size-5"
}
const _hoisted_9 = {
  key: 3,
  class: "mdi mdi-menu-up is-size-5"
}
const _hoisted_10 = { class: "is-size-7 has-text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_number_animation = _resolveComponent("n-number-animation")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.title), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      (typeof _ctx.value === 'number')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "count-value is-size-3 is-line-height-3 has-text-weight-bold",
            style: _normalizeStyle({ color: _ctx.valueColor || 'white'})
          }, [
            _createVNode(_component_n_number_animation, {
              from: _ctx.previous,
              to: _ctx.next,
              active: !_ctx.loading
            }, null, 8 /* PROPS */, ["from", "to", "active"]),
            (_ctx.unit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.unit), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ], 4 /* STYLE */))
        : (typeof _ctx.value === 'string')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.tooltip)
                ? (_openBlock(), _createBlock(_component_n_tooltip, { key: 0 }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: _ctx.valueColor || 'white'})
                      }, _toDisplayString(_ctx.value), 5 /* TEXT, STYLE */)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.tooltip), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    style: _normalizeStyle({ color: _ctx.valueColor || 'white'})
                  }, _toDisplayString(_ctx.value), 5 /* TEXT, STYLE */))
            ]))
          : _createCommentVNode("v-if", true),
      (_ctx.$slots.subvalue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "subvalue")
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: _normalizeClass(["subvalue is-size-6 is-line-height-6 has-text-weight-semibold", [_ctx.variationColor]])
          }, [
            (_ctx.variation > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "+"))
              : _createCommentVNode("v-if", true),
            (_ctx.variation && typeof _ctx.value === 'number')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.variation), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_ctx.variation < 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8))
              : _createCommentVNode("v-if", true),
            (_ctx.variation > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */))
    ]),
    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.description), 1 /* TEXT */)
  ]))
}